import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
  Grid,
  TextField,
  Typography,
  FormControl,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import currency from "currency.js";
import NumericTextField from "../../common/component/numeric/NumericTextField";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";

export default function AddCustomOption(props) {
  const { variantKey } = props;

  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setName("");
    setAmount("");
    setOpen(false);
  };

  const canSubmit = Boolean(name?.trim());

  return (
    <>
      <Box
        component="span"
        onClick={props.disabled ? undefined : () => setOpen(true)}
        sx={{
          display: "flex",
          flex: 1,
          width: "100%",
          minHeight: 0,
          ...(props.disabled ? { pointerEvents: "none", cursor: "not-allowed" } : {}),
        }}
        aria-disabled={props.disabled ? "true" : undefined}
      >
        {props.children}
      </Box>
      {open && (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>
            {props.label}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ minHeight: "250px" }}>
            <Box pt={2}>
              <Box mb={3}>
                <Typography variant="body1" color="textSecondary">
                  Custom option allows you to enter a value that's not included in your standard
                  list of options. If you plan to use a custom item type often, use Online Chat to
                  request it to be added to your catalog.
                </Typography>
              </Box>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    value={name}
                    label="Name"
                    name="name"
                    variant="outlined"
                    fullWidth
                    required
                    onChange={(e) => setName(e.target.value)}
                    inputProps={{ maxLength: 100 }}
                    helperText=""
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <NumericTextField
                      startIcon={<AttachMoneyOutlinedIcon />}
                      allowNegative={false}
                      decimalScale={2}
                      value={amount}
                      onChange={(value) => {
                        setAmount(value);
                      }}
                      label="Amount (optional)"
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>
                {variantKey === "size" && (
                  <Grid item xs={12}>
                    <Alert severity="info">
                      Please note that any size-specific variant options (e.g. availability,
                      surcharge, etc) will not apply to custom sizes. The variant options will
                      fallback to the default options. Be sure to check all variant selections to
                      ensure accuracy.
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => {
                const o = { name: name.trim() };
                const amountNum = currency(amount).value;
                if (amountNum > 0) {
                  o.pricing = { type: "fixed", amount: amountNum };
                }
                props.onChange(o);
                handleClose();
              }}
              disabled={!canSubmit}
            >
              ADD OPTION
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
